import { useState } from 'react';
import { useGetChapterQuery, useGetProgramQuery, useGetStudyLogQuery } from '../../../../../gen/graphql';
import { LOWER_META_TITLE, SERVICE_NAME } from '../../../../../const/Service';
import { ApolloUtil } from '../../../../../utils/ApolloUtil';

/** 戻り値の型 */
interface Result {
  studyLogData: ApolloUtil.QueryResult<typeof useGetStudyLogQuery>;
  metaTitle: string;
  metaDescription: string;
  chapterData: ApolloUtil.QueryResult<typeof useGetChapterQuery>;
  programData: ApolloUtil.QueryResult<typeof useGetProgramQuery>;
}

/** 章詳細コンテンツを取得するカスタムフック */
export function useChapterDetailContent(
  programID: number,
  chapterID: number,
  userID: number | undefined,
  skipStudyLog: boolean,
  chapterIncludedExam: boolean,
): Result {
  // 章の理解度の取得
  const studyLogData = useGetStudyLogQuery({ variables: { chapterID }, skip: skipStudyLog });

  // 章の取得とメタ情報
  const [chapterData, metaTitle, metaDescription] = useGetChapter(chapterID, chapterIncludedExam);

  // 教材の取得
  const programData = useGetProgramQuery({ variables: { programID: programID, userID: userID } });

  return {
    studyLogData: ApolloUtil.toQueryResult(studyLogData),
    metaTitle: metaTitle,
    metaDescription: metaDescription,
    chapterData: ApolloUtil.toQueryResult(chapterData),
    programData: ApolloUtil.toQueryResult(programData),
  };
}

/** 章の取得とメタ情報 */
function useGetChapter(
  chapterID: number,
  chapterIncludedExam: boolean,
): [ReturnType<typeof useGetChapterQuery>, string, string] {
  const [metaTitle, setMetaTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');

  const chapter = useGetChapterQuery({
    variables: { chapterID: chapterID, includeExam: chapterIncludedExam },
    onCompleted: (data) => {
      setMetaTitle(`${data?.chapter?.title} | ${LOWER_META_TITLE}`);
      setMetaDescription(`${SERVICE_NAME}の章ページです。この章では、${data?.chapter?.description}`);
    },
  });

  return [chapter, metaTitle, metaDescription];
}
